import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGamepadControlsDown"><Path d="M8.5 21.5H15.5V17.25L12 13.75L8.5 17.25V21.5Z" fill="currentColor" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 2.5H8.5V6.75L12 10.25L15.5 6.75V2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 15.5V8.5H17.25L13.75 12L17.25 15.5H21.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 8.5L2.5 15.5H6.75L10.25 12L6.75 8.5H2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGamepadControlsDown;
